import { useTranslation } from 'react-i18next';
import { t } from "../../hooks/useAppTranslation";
import {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../hooks/hooks";
import * as urls from "../../Properties/Properties";
import {getControllingEntitySubjects} from "../../Redux/Actions/ControllingEntitySubjects";
import {getProjectsData} from "../../Redux/Actions/Projects";
import {IProject} from "../../Redux/Reducers/projects";
import {DictionaryFormContainer} from "../DictionaryForm/DictionaryFormContainer";
import {getServicePromise} from "../HttpService/HttpService";
import PopUp from "../PopUp/PopUp";
import {ExternalControlForm, FormValues} from "./ExternalControlForm";
import {IdInfoSect} from "./IdInfoSect";
import {ProjectTable} from "./ProjectTable";

type Props = {};

export interface IFields {
  name?: string;
  beneficiaryId?: string;
  number?: string;
  title?: string;
  ownnumber?: string;
  controlId?: string;
  dateFrom: Date | string;
  dateTo: Date | string;
  description?: string;
  typeId?: string;
  typeDescription?: string;
  controllingSubject?: string;
  controllingSubjectId?: number;
  controlResult?: string;
  controlResultId?: number;
  projectId?: string;
  controlledSubject?: boolean;
  pzpControl?: boolean;
  hasConsequences?: boolean;
}

export interface IDictionary {
  active: boolean;
  abbrev?: string;
  creationDate?: string | Date;
  description: string;
  dictName?: string;
  dictNumber?: string;
  entryId: number;
  modifiationDate?: string | Date;
  modyfingPerson?: string | Date;
  personCreateing?: string | Date;
}

export interface ICustomSelectValues {
  label: string;
  value: number;
}

export const getValueFromId = (id: number, dict: IDictionary[]) => {
  return dict.find((el) => el.entryId === id)?.description;
};

export const getIDFromValue = (value: string, dict: IDictionary[]) => {
  return dict.find((el) => el.description === value)?.entryId;
};

export const ExternalControlContainer: React.FC<Props> = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  
  const history = useHistory();
  const dispatch = useAppDispatch();


  const { projects } = useAppSelector((state) => {
    const filterByImplementationLevel = (a: any) => {
      const selectedProgramCode = (state.programs as any)?.selected?.code;
      if (selectedProgramCode) {
        return a.implementationLevel?.startsWith(selectedProgramCode);
      }
      return true;
    };
    return {
      ...state.projects,
      projects: state.projects.projects.filter(filterByImplementationLevel)
    }
  });


  const userData = useAppSelector((state) => state.userData);
  const dictControllingSubjects: IDictionary[] = useAppSelector(
    (state) => state.controllingEntitySubjects.controllingEntitySubjects
  );

  const [redirectToControlId, setRedirectToControlId] = useState<number | boolean>(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [userRole, setUserRole] = useState<string | null>("");
  const [showTablePopup, setShowTablePopup] = useState(false);
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const [newSubjectPopup, setNewSubjectPopup] = useState(false);
  const [responseType, setResponseType] = useState("notify");
  const [choosedProject, setChoosedProject] = useState<IProject>();
  const param = useParams<{ controlId?: string; type?: string }>();
  const [controlUuid, setControlUuid] = useState<string | null>(null);
  const [fields, setFields] = useState<IFields>({
    name: "",
    number: "",
    title: "",
    ownnumber: "",
    dateFrom: "",
    dateTo: "",
    description: "",
    typeId: "",
    typeDescription: "",
    controllingSubject: "",
    controlResult: "",
    projectId: "",
    controlledSubject: false,
    pzpControl: false,
    hasConsequences: false,
  });
  const [subjects, setSubjects] = useState([]);
  const [pzpControls, setPzpControls] = useState([]);
  const [consequences, setConsequences] = useState([]);
  const [showPopup, setShowPopup] = useState(false)
  const [popup, setPopup] = useState({notification: '', type: '', title: ''})

  const [projError, setProjError] = useState("");

  /* DICTIONARIES */

  const [dictSubjectTypes, setDictSubjectTypes] = useState<IDictionary[]>([]);
  const [dictPzpTypes, setDictPzpTypes] = useState<IDictionary[]>([]);
  const [dictConsequencesTypes, setDictConsequencesTypes] = useState<
    IDictionary[]
  >([]);
  const [dictConsequencesPercents, setDictConsequencesPercents] = useState<
    IDictionary[]
  >([]);
  const [dictResults, setDictResults] = useState<IDictionary[]>([]);
  const [dictTypes, setDictTypes] = useState<IDictionary[]>([]);

  /* ------------- */

  useEffect(() => {
    // const url = urls.getExternalControlTypeDictionary()
    document.title = `e-Kontrole | Zarejestruj kontrolę`;

    getServicePromise(urls.getControlIdentifierTypeDictionary(lang), "GET").then(
      (res: IDictionary[]) => setDictSubjectTypes(res)
    );

    getServicePromise(urls.getControlConsequenceTypeDictionary(lang), "GET").then(
      (res: IDictionary[]) => setDictConsequencesTypes(res)
    );
    getServicePromise(urls.getExternalControlResultDictionary(lang), "GET").then(
      (res: IDictionary[]) => setDictResults(res)
    );
    getServicePromise(
      urls.getControlConsequenceCorrectionRateDictionary(),
      "GET"
    ).then((res: IDictionary[]) => setDictConsequencesPercents(res));

    getServicePromise(urls.getPzpControlTypeDictionary(), "GET").then(
      (res: IDictionary[]) => setDictPzpTypes(res)
    );

    getServicePromise(urls.getExternalControlTypeDictionary(lang), "GET").then(
      (res: IDictionary[]) => setDictTypes(res)
    );

    setUserRole(localStorage.getItem("userRole"));
  }, [lang]);

  useEffect(() => {
    if (param.controlId) {
      const url = urls.getExternalControlDetail(param.controlId, lang);
      getServicePromise(url, "GET").then((res) => {
        setControlUuid(res.uuid);
        setFields({
          name: res.name,
          number: res.number,
          title: res.title,
          ownnumber: res.ownnumber,
          dateFrom: res.dateFrom ? new Date(res.dateFrom) : "",
          dateTo: res.dateTo ? new Date(res.dateTo) : "",
          description: res.description,
          typeId: res.typeId.toString(),
          typeDescription: res.typeDescription || "",
          projectId: param.type === "edit" ? res.projectId : "",
          controlledSubject: res.subjects.length > 0,
          pzpControl: res.pzpControls.length > 0,
          hasConsequences: res.consequences.length > 0,
          controllingSubject: res.controllingSubject,
          controllingSubjectId: res.controllingSubjectId,
          controlResult: res.controlResult,
          controlResultId: res.controlResultId,
        });
        setSubjects(res.subjects);
        setConsequences(res.consequences);
        setPzpControls(res.pzpControls);
        if (param.type === "edit") {
          setChoosedProject(res.project);
        }
      }).catch(error => {
        setShowPopup(true)
        setPopup({
          notification: error || t('g-unknown-error'),
          type: 'error',
          title: t('g-error')
        })
      });
    }
  }, [history.location.pathname, lang]);

  useEffect(() => {
    const chProj = projects.find(
      (project: IProject) => project.projectId === fields.projectId
    );
    if (chProj) {
      setChoosedProject(chProj);
    }
  }, [projects, fields]);

  useEffect(() => {
    dispatch(getProjectsData());
      dispatch(getControllingEntitySubjects());
  }, []);

  const handleProjNumberPopup = () => {
    setShowTablePopup(true);
  };

  const goBack = () => {
    history.goBack();
  };


  const handleSave = (values: FormValues) => {
    if(!values.controlledSubject){
      values.subjects = []
    }
    if(!values.pzpControl){
      values.pzpControls = []
    }
    if(!values.hasConsequences){
      values.consequences = []
    }
    setProjError("");
    if (!choosedProject?.projectId) {
      setProjError(t('external-controls-select-project'));
      return;
    }

    const formData = {
      ...values,
      project: choosedProject
    };

    let url;
    let method;
    if (param.controlId && param.type === "edit") {
      // update data
      url = urls.getExternalControlsUpdate(param.controlId);
      method = "PUT";
      formData.controlId = param.controlId;
    } else {
      // save data
      url = urls.getExternalControlsSave();
      method = "POST";
    }

    getServicePromise(url, method, formData)
      .then((res) => {
        setRedirectToControlId(res.referenceId);
        setShowInfoPopup(true);
        setResponseType("notify");
        setDisableSubmit(true);
      })
      .catch((err) => {
        setRedirectToControlId(false);
        setShowInfoPopup(true);
        setResponseType("error");
      });
  };

  return (
    <>
      {!showPopup ? <>
        {param.type === "edit" && <h1>{t('external-controls-edit-control')}</h1>}

        {param.type === "copy" && <h1>{t('external-controls-create-copy-control')}</h1>}

        {!param.type && <h1>{t('g-register-control')}</h1>}

        <IdInfoSect
            name={choosedProject?.beneficiaryName}
            number={choosedProject?.number}
            controlNumber={fields.number}
            title={!param.type ? choosedProject?.title : choosedProject?.name}
            beneficiaryId={choosedProject?.beneficiaryIdentityNumber}
            handleProjNumberPopup={handleProjNumberPopup}
            controlId={param.controlId}
            mode={param.type ? param.type : "create"}
            error={projError}
        />

        <ExternalControlForm
            mode={param.type ? param.type : "create"}
            controlResults={dictResults}
            controllingSubjects={dictControllingSubjects.filter(
                (dict) => dict.active === true
            )}
            controlUuid={controlUuid}
            subjectTypes={dictSubjectTypes}
            pzpTypes={dictPzpTypes}
            consequencesTypes={dictConsequencesTypes}
            consequencesPercents={dictConsequencesPercents}
            handleSave={handleSave}
            addNewSubject={
              userRole === "SA" ? () => setNewSubjectPopup(true) : undefined
            }
            disableSubmit={disableSubmit}
            setDisableSubmit={setDisableSubmit}
            {...fields}
            subjects={subjects}
            projectUuid={choosedProject?.metaUUID}
            pzpControls={pzpControls}
            consequences={consequences}
        />
      </> : <button className='btn save-btn' id='plus_img_container' onClick={goBack}><i data-v-db6946bc='' aria-hidden='true'
                                                                                         className='v-icon material-icons theme--light v-list-text'>arrow_back</i><span className='uppercase'>{t('g-back')}</span>
      </button>}


      {newSubjectPopup && (
        <DictionaryFormContainer
          setVisibility={() => setNewSubjectPopup(false)}
        />
      )}

      {showTablePopup && (
        <PopUp
          type='custom'
          title={t('external-controls-dialog-selecting-project-number')}
          closePopUp={() => setShowTablePopup(false)}
          notification={
            <div className='popUp__content-scrolled'>
              <ProjectTable
                handleProject={(proj) => {
                  if (proj) {
                    setChoosedProject(proj);
                    setShowTablePopup(false);
                    setProjError("");
                  }
                }}
                handleClosePopup={() => setShowTablePopup(false)}
              />
            </div>
          }
        />
      )}
      {showPopup && (
          <PopUp
              type={popup.type}
              title={popup.title}
              notification={popup.notification}
              closePopUp={() => setShowPopup(false)}
          />
      )}
      {showInfoPopup && (
        <PopUp
          type={responseType}
          title={t('g-notification')}
          notification={
            responseType === "error"
              ? t('external-controls-dialog-control-could-not-saved')
              : t('external-controls-dialog-control-saved')
          }
          closePopUp={() => {
            if (redirectToControlId !== false){
              history.push(`/external_controls/edit/${redirectToControlId}`)
            }
            setShowInfoPopup(false);
          }}
        />
      )}
    </>
  );
};

export default ExternalControlContainer;
